import React from 'react'
import IndustiresCard from "../common/IndustiresCard"
import SectionTitle from "../common/SectionTitle"
import { getBackgroundClass } from "../../utils/sectionHelpers";

const Industries = ({ data }) => {
  const settings = data?.Settings || {};
  
      const backgroundClass = getBackgroundClass(settings.background);
  return (
    <>
      <section className={`solutions-area ptb-70 ${backgroundClass}`}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <SectionTitle data={data} />
            </div>
          </div>
          <div className="row gy-4 justify-content-center">
            <IndustiresCard data={data} />
          </div>
        </div>
      </section>
    </>
  )
}

export default Industries
